/* eslint-disable no-console */
/**
 * 语言标识映射工具
 */

const { LANG_MAP, SUPPORTED_LOCALES } = require('./constants');

/**
 * 将 Next.js locale 转换为 CMS 语言标识
 * @param {string} locale - Next.js locale (如 'ind')
 * @returns {string} CMS 语言标识 (如 'id')
 */
function toCmsLang(locale) {
  return LANG_MAP[locale] || locale;
}

/**
 * 从 URL 路径提取语言
 * @param {string} path - URL 路径（req.path，不包含查询参数）
 *   - '/' → 'en' (首页默认英文)
 *   - '/announce' → 'en' (默认英文，无语言前缀)
 *   - '/zh/announce' → 'zh'
 *   - '/ko' → 'ko' (韩语首页)
 *   - '/pt' → 'pt' (葡萄牙语首页)
 * @returns {string} Next.js locale (如 'zh', 'en', 'ko', 'pt')
 */
function extractLangFromPath(path) {
  // 🔑 处理根路径（首页）
  if (path === '/') {
    return 'en';
  }

  // 1. 尝试匹配路径开头的语言标识: /zh/xxx 或 /zh 或 /zh?query
  //    正则说明：^\/([a-z]{2,3})(?:\/|$|\?)
  //    - ^\/        : 必须以 / 开头
  //    - ([a-z]{2,3}): 捕获 2-3 个小写字母（语言代码）
  //    - (?:\/|$|\?): 后面必须跟着 / 或字符串结尾 或 ?（非捕获组）
  const pathMatch = path.match(/^\/([a-z]{2,3})(?:\/|$|\?)/);

  if (pathMatch) {
    const lang = pathMatch[1];

    // 2. 检查是否为支持的语言（排除 'en'，因为 en 没有路径前缀）
    //    例外情况：首页 /ko, /pt 等会被识别为对应语言
    if (lang !== 'en' && SUPPORTED_LOCALES.includes(lang)) {
      return lang;
    }
  }

  // 3. 如果路径没有语言前缀，或者前缀不是支持的语言，返回默认语言 'en'
  // 例如: /announce, /about, /en/xxx, /unknownlang/xxx 都返回 'en'
  return 'en';
}

/**
 * 检查是否为支持的语言
 * @param {string} locale - 语言标识
 * @returns {boolean}
 */
function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale);
}

module.exports = {
  toCmsLang,
  extractLangFromPath,
  isSupportedLocale,
  SUPPORTED_LOCALES,
};
